<template>
    <div class="main-content-datawarehousing">
      <div class="main-content-top">
            <div class="left">
                <!-- 板块类型 -->
                <div class="left-item" v-for="(item,index) in warehousingType" :key="index" @click="addWarehousing(item.type)">
                    <span class="left-item-icon"><i :class="item.icon"></i></span>
                    <span class="left-item-tit">{{item.tips}}</span>
                </div>
            </div>
            <div class="right">
                <input type="text" class="model-title" v-model="modelName" placeholder="请输入仪表盘名称"/>
                <el-button type="primary" @click="saveData">保存</el-button>
                <el-button @click="closePage">返回</el-button>
            </div>
      </div>
      <div class="main-content-center">
          <grid-layout
             :layout="warehousing"
             :col-num="96"
             :row-height="5"
             :is-draggable="isDraggable"
             :is-resizable="isResizable"
             :is-mirrored="false"
             :autoSize="true"
             :vertical-compact="true"
             :margin="[10, 10]"
             :use-css-transforms="true"
             @layout-created="layoutCreatedEvent"
             @layout-before-mount="layoutBeforeMountEvent"
             @layout-mounted="layoutMountedEvent"
             @layout-ready="layoutReadyEvent"
             @layout-updated="layoutUpdatedEvent"
           >
             <grid-item v-for="(item,index) in warehousing"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                :key="item.i"
                @resize="resizeEvent"
                @move="moveEvent"
                @resized="resizedEvent"
                @moved="movedEvent"
             >
                <div class="tool-bar">
                    <div class="tit">
                        <input type="text" v-model="item.name" class="grid-item-title" :placeholder="getItemTit(item)"/>
                    </div>
                    <div class="tool-bar-opera">
                        <div class="up-tool" v-if="item.dataType===1">
                            <i class="el-icon-edit" @click="configBI(2,item)"></i>
                        </div>
                        <div class="up-tool" v-else>
                           <i class="el-icon-edit" @click="updateItem(item)" title="配置模块数据源"></i>
                        </div>
                        <div class="search-tool" v-if="item.dataType===1||item.dataType===3||item.dataType===4">
                            <i class="iconfont icon-other-xuanzhong2x" @click="showItemSearch(item)" title="配置数据默认搜索条件"></i>
                        </div>
                        <div  class="search-field" v-if="item.dataType===1||item.dataType===3||item.dataType===4">
                            <i class="iconfont icon-other-guolv1" @click="showItemSearchConfig(item)" title="配置快捷搜索条件"></i>
                        </div>
                       <div class="field-tool" v-if="item.dataType===3||item.dataType===4">
                             <i class="iconfont icon-other-ziduanxianshi" @click="showFieldConfig(item)" title="配置数据表格显示字段"></i>
                         </div>
                        <div class="del-tool">
                            <i class="el-icon-delete" @click="deleteItem(item)" title="删除模块"></i>
                        </div>
                    </div>
                </div>
                <div class="main-content-body">
                    <!-- 搜索 -->
                    <div class="main-content-search" v-if="item.moduleSearch">
                        <div class="main-content-search-tit">

                        </div>
                        <div class="main-content-search-box">
                            <DataWarehousingSearch
                                    :ref="item.i+'dataWarehousingSearch'"
                                    :moduleSearchObj="item.moduleSearchObj"
                                    >
                            </DataWarehousingSearch>
                        </div>
                        <div class="item-field-search-content-btn">
                            <el-button @click="celSetForm(item)">关闭</el-button>
                            <el-button type="success" @click="subSetForm(item)">确定</el-button>
                        </div>
                    </div>
                    <!-- 字段展现 -->
                    <div  class="main-content-field-select" v-show="item.showFilterField">
                         <SelectMultiple
                            :ref="item.i+'selectMultiple'"
                            :sourceOptions="item.sourceOptions"
                            >
                         </SelectMultiple>
                         <div class="btn-content">
                             <el-button @click="celSetField(item)">关闭</el-button>
                             <el-button type="primary" @click="showAllField(item)">全部展现</el-button>
                             <el-button type="success" @click="subSetField(item)">确定</el-button>
                         </div>
                    </div>
                    <!-- BI -->
                    <DashBoard  :ref="item.i+'dashBoard'"  v-if="item.dataType===1"
                                :dashBoardWidth="item.dashBoardWidth"
                                :dashBoardHeight="item.dashBoardHeight"
                                :showSearchList="item.showSearchList"
                                :chartType="item.chartType"
                                :dataId="item.dataId"
                                :searchCondition="item.searchCondition"
                                :index="item.id"
                                :key="biTimer"
                                >
                    </DashBoard>
                    <!-- 工作台 -->
                    <WorkPlant
                            :ref="item.i+'workPlant'"
                            :dataList="item.dataList"
                            v-if="item.dataType===2"
                            :key="wpTimer"
                            >
                    </WorkPlant>
                    <!-- 数据表格 -->
                    <TableData
                            :ref="item.i+'dataTable'"
                            v-if="item.dataType===3"
                            :modelId="item.modelId"
                            :formId="item.formId"
                            :modelObj="item.modelObj"
                            :showSearchList="item.showSearchList"
                            :searchCondition="item.searchCondition"
                            :selectedFields="item.selectedFields"
                            :selectedModel="item.selectedModel"
                            :tableHeight="item.tableHeight"
                            :key="tpTimer"
                            >
                    </TableData>
                    <!-- 数据报表 -->
                    <TableData
                            :ref="item.i+'dataTable'"
                            v-if="item.dataType===4"
                            :modelId="item.modelId"
                            :formId="item.formId"
                            :modelObj="item.modelObj"
                            :showSearchList="item.showSearchList"
                            :searchCondition="item.searchCondition"
                            :selectedFields="item.selectedFields"
                            :selectedModel="item.selectedModel"
                            :tableHeight="item.tableHeight"
                            :key="rpTimer"
                            >
                    </TableData>
                    <!-- 聚合报表 -->
                    <TableData
                            :ref="item.i+'dataTable'"
                            v-if="item.dataType===11"
                            :modelId="item.modelId"
                            :formId="item.formId"
                            :modelObj="item.modelObj"
                            :showSearchList="item.showSearchList"
                            :searchCondition="item.searchCondition"
                            :selectedFields="item.selectedFields"
                            :selectedModel="item.selectedModel"
                            :tableHeight="item.tableHeight"
                            :key="jhTimer"
                            >
                    </TableData>
                    <!-- 单项值统计 -->
                    <StatisticsPreview
                            :ref="item.i+'statistics'"
                            v-if="item.dataType===5"
                            :fieldConfig="item.fieldConfig"
                            :isDesign="true"
                            :key="spTimer"
                            >
                    </StatisticsPreview>
                    <!-- 数字化工具 -->
                    <DigitalToolsPreview
                            :ref="item.i+'digitalTools'"
                            :dataList="item.dataList"
                            v-if="item.dataType===6"
                            :key="dpTimer"
                            >
                    </DigitalToolsPreview>
                    <!-- 快捷入口 -->
                    <QuickEntry
                        :ref="item.i+'quickEntry'"
                        v-if="item.dataType===7"
                        :mode="item.mode"
                        :key="qeTime"
                        :chooseDataIds="item.chooseDataIds"
                        :dataList="item.dataList"
                        >
                    </QuickEntry>
                    <!-- 分组统计 -->
                    <StatisticsGroupPreview
                       :ref="item.i+'statisticsGroup'"
                       v-if="item.dataType===8"
                       :fieldConfig="item.fieldConfig"
                       :isDesign="true"
                       :key="spgTimer"
                        >
                    </StatisticsGroupPreview>
                    <!-- 进度条 -->
                    <ProgressBarPreview
                        :ref="item.i+'progressBar'"
                        v-if="item.dataType===9"
                        :progressBarConfig="item.progressBarConfig"
                        :key="pbpTimer"
                        >
                    </ProgressBarPreview>
                    <!-- 数据进度 -->
                    <DataProgressBarPreview
                    :ref="item.i+'dataProgressBar'"
                    v-if="item.dataType===10"
                    :dataProgressBarConfig="item.dataProgressBarConfig"
                    :key="dpbpTimer"
                    >
                    </DataProgressBarPreview>
                </div>
             </grid-item>
           </grid-layout>
      </div>
 <!--     <div class="main-content-bottom">

      </div> -->
      <!-- BI配置 -->
      <el-dialog class="showConfigDashBoard"  custom-class="showConfigDashBoard" append-to-body :visible.sync="showConfigDashBoard" fullscreen>
         <ConfigDashBoard></ConfigDashBoard>
      </el-dialog>
      <!-- BI引入-->
      <el-dialog class="showDashBoardModel"  custom-class="showDashBoardModel" append-to-body :visible.sync="showDashBoardModel" destroy-on-close fullscreen :show-close="false">
        <DashBoardModelList :modelType="modelType" @configDashBoardModelList="configDashBoardModelList" @cancelDashBoardModelList="cancelDashBoardModelList"></DashBoardModelList>
      </el-dialog>
      <!-- table和report引入-->
      <el-dialog
            class="showDashBoardModel"
            custom-class="showDashBoardModel"
            append-to-body
            :visible.sync="showDataTableModel"
            destroy-on-close fullscreen
            :show-close="false">
            <DataTableModelList
                v-if="showDataTableModel"
                :dataType="dataType"
                :selectType="selectType"
                @configDataProcessMode="configDataProcessMode"
                @configDataTableModelList="configDataTableModelList"
                @configDataMultipleModelList="configDataMultipleModelList"
                @cancelDataTableModelList="cancelDataTableModelList">
            </DataTableModelList>
      </el-dialog>
      <!-- 统计项配置 -->
      <el-dialog class="showStatistics"  custom-class="showStatistics" append-to-body :visible.sync="showStatistics" v-if="showStatistics" fullscreen>
         <Statistics v-if="showStatistics" @configStatistics="configStatistics" :fieldConfig="currObj.fieldConfig"></Statistics>
      </el-dialog>
      <!-- 工作台配置 -->
      <el-dialog class="showWorkPlantConfig"  custom-class="showWorkPlantConfig" append-to-body :visible.sync="showWorkPlantConfig" fullscreen>
        <WorkPlantConfig v-if="showWorkPlantConfig"  @configWorkPlantConfig="configWorkPlantConfig" @closeWorkPlantConfig="closeWorkPlantConfig" :dataList="dataList">

        </WorkPlantConfig>
      </el-dialog>
      <!-- 数字化工具配置 -->
      <el-dialog class="showDigitalToolsConfig"  custom-class="showDigitalToolsConfig" append-to-body :visible.sync="showDigitalToolsConfig" fullscreen>
        <DigitalToolsConfig
                v-if="showDigitalToolsConfig"
                @configDigitalToolsConfig="configDigitalToolsConfig"
                @closeDigitalToolsConfig="closeDigitalToolsConfig"
                >
        </DigitalToolsConfig>
      </el-dialog>
      <!-- 分组统计配置 -->
      <el-dialog class="showStatisticsGroup"  custom-class="showStatisticsGroup" append-to-body :visible.sync="showStatisticsGroup" fullscreen>
         <StatisticsGroup v-if="showStatisticsGroup" @configStatisticsGroup="configStatisticsGroup" :fieldConfig="currObj.fieldConfig"></StatisticsGroup>
      </el-dialog>
      <!-- 进度条配置 -->
      <el-dialog class="showProgressBar"  custom-class="showProgressBar" append-to-body :visible.sync="showProgressBar" fullscreen>
         <ProgressBarConfig v-if="showProgressBar" @configProgressBar="configProgressBar" :progressBarConfig="progressBarConfig"></ProgressBarConfig>
      </el-dialog>
      <!-- 数据进度配置 -->
      <el-dialog class="showDataProgressBar"  custom-class="showDataProgressBar" append-to-body :visible.sync="showDataProgressBar" fullscreen>
         <DataProgressBarConfig v-if="showDataProgressBar" @configDataProgressBar="configDataProgressBar" :dataProgressBarConfig="dataProgressBarConfig">
         </DataProgressBarConfig>
      </el-dialog>
      <!-- 常用搜索条件配置 -->
      <el-dialog class="showSearchConfig"  custom-class="showSearchConfig" append-to-body :visible.sync="showSearchConfig" fullscreen>
        <SearchTooConfig :moduleObj="currObj" :key="searchToolConfigTime" @configSearchTool="configSearchTool"></SearchTooConfig>
      </el-dialog>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import VueGridLayout from 'vue-grid-layout';
import DashBoard from '@/components/DataWarehousing/DashBoard';
import ConfigDashBoard from '@/components/DataWarehousing/ConfigDashBoard';
import Statistics from '@/components/DataWarehousing/Statistics';
import StatisticsGroup from '@/components/DataWarehousing/StatisticsGroup';
import DashBoardModelList from '@/components/DataWarehousing/DashBoardModelList';
import DataTableModelList from '@/components/DataWarehousing/DataTableModelList';
import StatisticsPreview from '@/components/DataWarehousing/StatisticsPreview';
import StatisticsGroupPreview from '@/components/DataWarehousing/StatisticsGroupPreview';
import WorkPlant from '@/components/DataWarehousing//WorkPlant';
import TableData from '@/components/DataWarehousing/TableData';
import QuickEntry from '@/components/DataWarehousing/QuickEntry';
import WorkPlantConfig from '@/components/DataWarehousing/WorkPlantConfig';
import DigitalToolsConfig from '@/components/DataWarehousing/DigitalToolsConfig';
import DigitalToolsPreview from '@/components/DataWarehousing/DigitalToolsPreview';
import ProgressBarConfig from '@/components/DataWarehousing/ProgressBarConfig';
import DataProgressBarConfig from '@/components/DataWarehousing/DataProgressBarConfig';
import ProgressBarPreview from '@/components/DataWarehousing/ProgressBarPreview';
import DataProgressBarPreview from '@/components/DataWarehousing/DataProgressBarPreview';
import DataWarehousingSearch from '@/components/DataWarehousing/DataWarehousingSearch';
import SearchTooConfig from '@/components/DataWarehousing/SearchTooConfig';
import layoutData from '@/components/DataWarehousing/DataFormationSource.json';
import {getFormDashBoardData, getWarehousing} from '@/data-model';
import SelectMultiple from '@/components/SelectMultiple';
export default{
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        DashBoard: DashBoard,
        WorkPlant: WorkPlant,
        ConfigDashBoard: ConfigDashBoard,
        DashBoardModelList: DashBoardModelList,
        TableData: TableData,
        DataTableModelList: DataTableModelList,
        Statistics: Statistics,
        StatisticsPreview: StatisticsPreview,
        QuickEntry: QuickEntry,
        WorkPlantConfig: WorkPlantConfig,
        DigitalToolsConfig: DigitalToolsConfig,
        DigitalToolsPreview: DigitalToolsPreview,
        StatisticsGroup: StatisticsGroup,
        StatisticsGroupPreview: StatisticsGroupPreview,
        ProgressBarConfig: ProgressBarConfig,
        ProgressBarPreview: ProgressBarPreview,
        DataProgressBarConfig: DataProgressBarConfig,
        DataProgressBarPreview: DataProgressBarPreview,
        DataWarehousingSearch: DataWarehousingSearch,
        SelectMultiple: SelectMultiple,
        SearchTooConfig: SearchTooConfig
    },
    props: {
        wareHousingId: {
            type: String
        },
        warehousingPreviewTitle: {
            type: String
        }
    },
    data () {
        return {
            // 布局数据
            biTimer: '',
            spTimer: '',
            wpTimer: '',
            rpTimer: '',
            jhTimer: '',
            tpTimer: '',
            dpTimer: '',
            spgTimer: '',
            pbpTimer: '',
            dpbpTimer: '',
            qeTime: '',
            searchToolConfigTime: '',
            layoutData: [],
            isDraggable: true,
            isResizable: true,
            warehousing: [],
            warehousingType: [
                {
                    icon: 'iconfont icon-other-bi',
                    type: '1',
                    tips: 'B I 图'
                },
                {
                    icon: 'iconfont icon-other-xitonggongnengpeizhi',
                    type: '2',
                    tips: '系统功能'
                },
                {
                    icon: 'iconfont icon-other-bianzu14',
                    type: '3',
                    tips: '数据表格'
                },
                {
                    icon: 'iconfont icon-other-baobiao',
                    type: '4',
                    tips: '数据报表'
                },
                {
                    icon: 'iconfont icon-other-shebeijuhe',
                    type: '11',
                    tips: '聚合报表'
                },
                {
                    icon: 'iconfont icon-other-sp-baobiaotongji-xiangmuzongtiqingkuang',
                    type: '5',
                    tips: '单项统计'
                },
                {
                    icon: 'iconfont icon-other-fenzutongji',
                    type: '8',
                    tips: '分组统计'
                },
                {
                    icon: 'iconfont icon-other-shuzihuagongju',
                    type: '6',
                    tips: '数字化工具'
                },
                {
                    icon: 'iconfont icon-other-kuaijierukou',
                    type: '7',
                    tips: '快捷入口'
                },
                {
                    icon: 'iconfont icon-other-jindutiaozhanweifu',
                    type: '9',
                    tips: '进度条'
                },
                {
                    icon: 'iconfont icon-other-huabanfuben',
                    type: '10',
                    tips: '数据进度'
                }
            ],
            showConfigDashBoard: false,
            showDashBoardModel: false,
            showDataTableModel: false,
            showStatistics: false,
            showWorkPlantConfig: false,
            showDigitalToolsConfig: false,
            showStatisticsGroup: false,
            showProgressBar: false,
            showDataProgressBar: false,
            showSearchConfig: false,
            modelType: 1,
            dataType: 1,
            currObj: {},
            modelName: '',
            id: '',
            selectType: 1,
            dataList: [],
            progressBarConfig: {},
            dataProgressBarConfig: {},
            moduleSearch: false,
            moduleSearchObj: {

            }

        };
    },
    created () {
        if (this.wareHousingId && this.wareHousingId !== '') {
            this.modelName = this.warehousingPreviewTitle;
            this.echoWarehousingData();
        }
    },
    methods: {
        resizeEvent (i, newH, newW, newHPx, newWPx) {
        },
        moveEvent (i, newX, newY) {
        },
        resizedEvent (i, newH, newW, newHPx, newWPx) {
            let obj = this.warehousing.find(item => item.i === i);
            if (obj.dataType === 1) { // BI
                obj.dashBoardWidth = (newWPx - 30) + 'px';
                obj.dashBoardHeight = (newHPx - 30) + 'px';
                let o = i + 'dashBoard';
                this.$refs[o][0].resizeChart(obj.id);
            }
        },
        movedEvent (i, newX, newY) {
        },
        // 布局组件的生命周期  参数newLayout=> 布局的数据 每个布局数据
        layoutCreatedEvent (newLayout) {
        },
        layoutBeforeMountEvent (newLayout) {
        },
        layoutMountedEvent (newLayout) {
        },
        layoutReadyEvent (newLayout) {
        },
        layoutUpdatedEvent (newLayout) {
        },
        closePage () {
            window.sessionStorage.removeItem('warehousing');
            this.$emit('closeDataWarehousing');
        },
        addWarehousing (obj) {
            let x = 0;
            let y = 0;
            if (this.warehousing.length > 0) {
                let o = this.warehousing[this.warehousing.length - 1];
                x = o.x + 32;
                if (x + 32 > 96) { // 需要另起一行
                    x = 0;
                    y = o.h + 32;
                }
            }
            switch (obj) {
            case '1':
                let biData = cloneDeep(layoutData.biData);
                biData.i = this.generateUUID();
                biData.x = x;
                biData.y = y;
                biData.id = this.generateUUID();
                this.warehousing.push(biData);
                break;
            case '2':
                let workPlant = cloneDeep(layoutData.workPlant);
                workPlant.i = this.generateUUID();
                workPlant.x = x;
                workPlant.y = y;
                workPlant.id = this.generateUUID();
                this.warehousing.push(workPlant);
                break;
            case '3':
                let dataTable = cloneDeep(layoutData.dataTable);
                dataTable.i = this.generateUUID();
                dataTable.x = x;
                dataTable.y = y;
                dataTable.id = this.generateUUID();
                this.warehousing.push(dataTable);
                break;
            case '4':
                let reportTable = cloneDeep(layoutData.reportTable);
                reportTable.i = this.generateUUID();
                reportTable.x = x;
                reportTable.y = y;
                reportTable.id = this.generateUUID();
                this.warehousing.push(reportTable);
                break;
            case '5':
                let statistics = cloneDeep(layoutData.statistics);
                statistics.i = this.generateUUID();
                statistics.x = x;
                statistics.y = y;
                statistics.id = this.generateUUID();
                this.warehousing.push(statistics);
                break;
            case '6':
                let digitalTools = cloneDeep(layoutData.digitalTools);
                digitalTools.i = this.generateUUID();
                digitalTools.x = x;
                digitalTools.y = y;
                digitalTools.id = this.generateUUID();
                this.warehousing.push(digitalTools);
                break;
            case '7':
                let quickEntry = cloneDeep(layoutData.quickEntry);
                quickEntry.i = this.generateUUID();
                quickEntry.x = x;
                quickEntry.y = y;
                quickEntry.id = this.generateUUID();
                this.warehousing.push(quickEntry);
                break;
            case '8':
                let statisticsGroup = cloneDeep(layoutData.statisticsGroup);
                statisticsGroup.i = this.generateUUID();
                statisticsGroup.x = x;
                statisticsGroup.y = y;
                statisticsGroup.id = this.generateUUID();
                this.warehousing.push(statisticsGroup);
                break;
            case '9':
                let progressBar = cloneDeep(layoutData.progressBar);
                progressBar.i = this.generateUUID();
                progressBar.x = x;
                progressBar.y = y;
                progressBar.id = this.generateUUID();
                this.warehousing.push(progressBar);
                break;
            case '10':
                let dataProgressBar = cloneDeep(layoutData.dataProgressBar);
                dataProgressBar.i = this.generateUUID();
                dataProgressBar.x = x;
                dataProgressBar.y = y;
                dataProgressBar.id = this.generateUUID();
                this.warehousing.push(dataProgressBar);
                break;
            case '11':
                let aggregateTable = cloneDeep(layoutData.aggregateTable);
                aggregateTable.i = this.generateUUID();
                aggregateTable.x = x;
                aggregateTable.y = y;
                aggregateTable.id = this.generateUUID();
                this.warehousing.push(aggregateTable);
                break;
            }
        },
        generateUUID () {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === 'function') {
                d += window.performance.now(); // use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid.replace(RegExp('-', 'g'), '');
        },
        saveData () {
            if (this.modelName === '') {
                this.$message.error('请输入仪表盘名称');
                return;
            }
            for (let i = 0; i < this.warehousing.length; i++) {
                let obj = this.warehousing[i];
                if (obj.dataType === 1) {
                    if (obj.name === '') {
                        this.$message.error('您还有BI图板块的名称没有填写');
                        return;
                    }
                }
            }
            let param = {};
            param.warehousing = JSON.stringify(this.warehousing);
            param.modelName = this.modelName;
            param.formName = this.modelName;
            param.modelType = 5;
            this.$emit('sendWareHousing', param);
        },
        updateItem (obj) {
            this.currObj = obj;
            switch (obj.dataType) {
            case 1:
                this.showConfigDashBoard = true;
                break;
            case 2:
                this.dataList = obj.dataList;
                this.showWorkPlantConfig = true;
                break;
            case 3:
                this.dataType = 1;
                this.selectType = 1;
                this.showDataTableModel = true;
                break;
            case 4:
                this.dataType = 2;
                this.selectType = 1;
                this.showDataTableModel = true;
                break;
            case 5:// 统计项配置
                this.showStatistics = true;
                break;
            case 6:// 数子化工具
                this.showDigitalToolsConfig = true;
                break;
            case 7:// 快捷入口
                this.dataType = 1;
                this.selectType = 2;
                this.showDataTableModel = true;
                break;
            case 8:// 分组统计
                this.showStatisticsGroup = true;
                break;
            case 9:// 进度条
                this.progressBarConfig = obj.progressBarConfig;
                this.showProgressBar = true;
                break;
            case 10:// 数据进度条
                this.dataProgressBarConfig = obj.dataProgressBarConfig;
                this.showDataProgressBar = true;
                break;
            case 11:// 聚合报表
                this.dataType = 6;
                this.selectType = 1;
                this.showDataTableModel = true;
                break;
            }
        },
        deleteItem (obj) {
            for (let i = 0; i < this.warehousing.length; i++) {
                let o = this.warehousing[i];
                if (o.id === obj.id) {
                    this.warehousing.splice(i, 1);
                }
            }
        },
        showItemSearch (obj) {
            let dataType = obj.dataType;
            switch (dataType) {
            case 1:// BI
                if (obj.dataId !== '') {
                    obj.moduleSearch = true;
                } else {
                    this.$message.error('请先配置BI数据源');
                }
                break;
            case 3:
                if (obj.modelId !== '') {
                    obj.moduleSearch = true;
                } else {
                    this.$message.error('请先配置数据表格数据源');
                }
                break;
            case 4:
                if (obj.modelId !== '') {
                    obj.moduleSearch = true;
                } else {
                    this.$message.error('请先配置数据报表数据源');
                }
                break;
            }
        },
        showItemSearchConfig (obj) {
            this.currObj = cloneDeep(obj);
            let dataType = obj.dataType;
            this.searchToolConfigTime = new Date().getTime();
            switch (dataType) {
            case 1:// BI
                if (obj.dataId !== '') {
                    this.showSearchConfig = true;
                } else {
                    this.$message.error('请先配置BI数据源');
                }
                break;
            case 3:
                if (obj.modelId !== '') {
                    this.showSearchConfig = true;
                } else {
                    this.$message.error('请先配置数据表格数据源');
                }
                break;
            case 4:
                if (obj.modelId !== '') {
                    this.showSearchConfig = true;
                } else {
                    this.$message.error('请先配置数据报表数据源');
                }
                break;
            }
        },
        showFieldConfig (obj) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let sourceOptions = [];
            let re = obj.i + 'dataTable';
            let tableColumnsView = this.$refs[re][0].getTableColumns();
            tableColumnsView.forEach((field) => {
                if (field.id !== 'approvalStatus' && field.id !== 'approvalResultDetail' && field.id !== 'num' && field.id !== 'processInstanceName') {
                    sourceOptions.push(field);
                }
            });
            sourceOptions.unshift({ id: 'ALL_SELECT', label: 'ALL' });
            obj.sourceOptions = sourceOptions;
            let re1 = obj.i + 'selectMultiple';
            setTimeout(() => { // 调用子组件的方法
                this.$refs[re1][0].initFields();// 每次切换model时清空显示字段
            }, 100);
            loading.close();
            obj.showFilterField = true;
            this.warehousingType = cloneDeep(this.warehousingType);
        },
        configBI (o, item) {
            this.currObj = item;
            if (o === 1) {
                this.showConfigDashBoard = true;
            } else {
                this.modelType = 3;
                this.showDashBoardModel = true;
            }
        },
        configDashBoardModelList (obj) {
            this.getBiData(obj);
            this.showDashBoardModel = false;
        },
        cancelDashBoardModelList () {
            this.showDashBoardModel = false;
        },
        configStatistics (obj) {
            console.log(obj);
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.fieldConfig = obj;
            console.log(this.warehousing);
            this.showStatistics = false;
            this.spTimer = new Date().getTime();
        },
        configStatisticsGroup (obj) {
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.fieldConfig = obj;
            this.showStatisticsGroup = false;
            this.spgTimer = new Date().getTime();
        },
        configProgressBar (obj, type) {
            let param = {};
            param.progressBarData = JSON.stringify(obj);
            param.progressBarType = type;
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.progressBarConfig = param;
            this.showProgressBar = false;
            this.pbpTimer = new Date().getTime();
        },
        configDataProgressBar (obj) {
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.dataProgressBarConfig = obj;
            this.showDataProgressBar = false;
            this.dpbpTimer = new Date().getTime();
        },
        async getBiData (obj) {
            // 2.列表/报表
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let iSearchCondition = {searchCondition: obj.searchCondition, formId: obj.formId};
            let res = await getFormDashBoardData(iSearchCondition);
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.chartType = res.chartType;
            if (res.conditionFields) { // BI有配置搜索条件
                let moduleSearchObj = {dataType: 1, conditionFields: JSON.parse(res.conditionFields), dataFormId: res.dataFormId, dataModelId: res.dataModelId};
                o.moduleSearchObj = moduleSearchObj;
            } else { // BI没有配置搜索条件
                let moduleSearchObj = {dataType: 1, conditionFields: [], dataFormId: res.dataFormId, dataModelId: res.dataModelId};
                o.moduleSearchObj = moduleSearchObj;
            }
            o.dataId = obj.formId;
            let re = this.currObj.i + 'dashBoard';
            this.$refs[re][0].renderModel(res);
            loading.close();
        },
        async echoWarehousingData () {
            let param = {modelId: this.wareHousingId};
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let o = await getWarehousing(param);
            loading.close();
            if (o.state === 'success') {
                let layout = JSON.parse(o.data.mouldData);
                this.warehousing = layout;
                this.id = o.data.id;
            }
        },
        async getformData (obj) {
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.modelId = obj.id;
            o.formId = obj.formId;
            o.modelObj = obj;
            o.selectedModel = {};
            let re = this.currObj.i + 'dataTable';
            obj.modelId = obj.id;
            let moduleSearchObj = {dataType: 1, conditionFields: [], dataFormId: o.formId, dataModelId: o.modelId};
            o.moduleSearchObj = moduleSearchObj;
            this.$refs[re][0].renderFormList(obj, true);
            this.$refs[re][0].getTableColumns();
        },
        configDataTableModelList (obj) {
            this.getformData(obj);
            this.qeTime = new Date().getTime();
            this.showDataTableModel = false;
        },
        configDataMultipleModelList (obj) {
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.dataList = obj;
            o.mode = 0;
            this.qeTime = new Date().getTime();
            this.showDataTableModel = false;
        },
        configDataProcessMode (mode, chooseData) {
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.mode = mode;
            if (chooseData.length > 0 && mode > 0) {
                let chooseDataIds = [];
                for (let i = 0; i < chooseData.length; i++) {
                    let currentObj = chooseData[i];
                    chooseDataIds.push(currentObj.id);
                }
                o.chooseDataIds = chooseDataIds.join(',');
                o.dataList = chooseData;
            }
            this.qeTime = new Date().getTime();
            this.showDataTableModel = false;
        },
        cancelDataTableModelList () {
            this.showDataTableModel = false;
        },
        closeWorkPlantConfig () {
            this.showWorkPlantConfig = false;
        },
        configWorkPlantConfig (obj) {
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.dataList = obj;
            this.wpTimer = new Date().getTime();
            this.showWorkPlantConfig = false;
        },
        configDigitalToolsConfig (obj) {
            let o = this.warehousing.find(item => item.i === this.currObj.i);
            o.dataList = obj;
            this.dpTimer = new Date().getTime();
            this.showDigitalToolsConfig = false;
        },
        closeDigitalToolsConfig () {
            this.showDigitalToolsConfig = false;
        },
        subSetForm (currObj) {
            let obj = this.warehousing.find(item => item.i === currObj.i);
            let o = currObj.i + 'dataWarehousingSearch';
            let conditionFields = this.$refs[o][0].renderSearchArry();
            obj.searchCondition = conditionFields;
            obj.moduleSearchObj.conditionFields = conditionFields;
            switch (currObj.dataType) {
            case 1:
                let re = currObj.i + 'dashBoard';
                this.$refs[re][0].getDashBoardData(currObj.searchCondition);
                break;
            case 3:
                let re1 = currObj.i + 'dataTable';
                this.$refs[re1][0].renderFormList(currObj.modelObj, false, currObj.searchCondition);
                break;
            case 4:
                let re2 = currObj.i + 'dataTable';
                this.$refs[re2][0].renderFormList(currObj.modelObj, false, currObj.searchCondition);
                break;
            }
            obj.moduleSearch = false;
        },
        subSetField (currObj) {
            let obj = this.warehousing.find(item => item.i === currObj.i);
            let o = currObj.i + 'selectMultiple';
            let selectedFields = this.$refs[o][0].getSelectFields();
            obj.selectedFields = selectedFields;
            let re = currObj.i + 'dataTable';
            this.$refs[re][0].gefieldFormList(selectedFields, currObj.searchCondition, currObj.modelObj);
            obj.showFilterField = false;
            this.warehousingType = cloneDeep(this.warehousingType);
        },
        celSetForm (currObj) {
            let obj = this.warehousing.find(item => item.i === currObj.i);
            obj.moduleSearch = false;
        },
        celSetField (currObj) {
            let obj = this.warehousing.find(item => item.i === currObj.i);
            obj.showFilterField = false;
            this.warehousingType = cloneDeep(this.warehousingType);
        },
        showAllField (currObj) {
            let obj = this.warehousing.find(item => item.i === currObj.i);
            obj.selectedFields = '';
            let re = currObj.i + 'dataTable';
            this.$refs[re][0].gefieldAllFormList('', currObj.searchCondition, currObj.modelObj);
            obj.showFilterField = false;
            this.warehousingType = cloneDeep(this.warehousingType);
        },
        getItemTit (obj) {
            let modelType = '';
            if (obj.dataType === 1) { // BI
                modelType = 'BI图';
            } else if (obj.dataType === 2) {
                modelType = '系统功能';
            } else if (obj.dataType === 3) {
                modelType = '数据表格';
            } else if (obj.dataType === 4) {
                modelType = '数据报表';
            } else if (obj.dataType === 5) {
                modelType = '单项统计';
            } else if (obj.dataType === 6) {
                modelType = '数字化工具';
            } else if (obj.dataType === 7) {
                modelType = '快捷入口';
            } else if (obj.dataType === 8) {
                modelType = '分组统计';
            } else if (obj.dataType === 9) {
                modelType = '进度条';
            } else if (obj.dataType === 10) {
                modelType = '数据进度';
            }
            let tit = `请输入${modelType}板块名称`;
            return tit;
        },
        configSearchTool (o) {
            let obj = this.warehousing.find(item => item.i === this.currObj.i);
            obj.showSearchList = o;
            if (obj.dataType === 1) {
                this.showSearchConfig = false;
                let re = this.currObj.i + 'dashBoard';
                this.$refs[re][0].renderSearchField(o);
            } else if (obj.dataType === 3 || obj.dataType === 4) {
                this.showSearchConfig = false;
                let re = this.currObj.i + 'dataTable';
                this.$refs[re][0].renderSearchField(o);
            }
        }
    }
};
</script>

<style lang="less">
    @import './DataWarehousingStyle.less';
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DataWarehousing.vue